module.exports = __webpack_public_path__ + "./img/VendedoresNotificaciones.14cf1ab02f64adcc072ff6494e96050e.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/VendedoresNotificaciones.png
// module id = ./public/img/Help/VendedoresNotificaciones.png
// module chunks = 0